(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-cookie-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const forms = [...root.querySelectorAll('[data-cookie-form]')];
      const bar = root.querySelector('[data-cart-bar]');
      const currency = new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency });
      const showCart = (cart) => {
        bar.hidden = cart.item_count === 0;
        root.querySelector('[data-cart-count]').textContent = root.dataset.countLabel.replace('[count]', cart.item_count);
        root.querySelector('[data-cart-total]').textContent = currency.format(cart.total_price / 100);
      };
      const menuLink = root.querySelector('.cp-hero .cp-btn');
      menuLink.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const target = root.querySelector('.cp-menu');
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      });
      let busy = false;
      forms.forEach((form) => form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        busy = true;
        const button = form.querySelector('[name="add"]');
        const status = form.closest('[data-product-card]').querySelector('[data-product-status]');
        const enabledButtons = forms.map((item) => item.querySelector('[name="add"]')).filter((item) => !item.disabled);
        enabledButtons.forEach((item) => { item.disabled = true; });
        button.textContent = root.dataset.addingLabel;
        status.textContent = '';
        let added = false;
        try {
          const payload = new FormData(form);
          payload.set('sections', 'cart-icon-bubble');
          payload.set('sections_url', window.location.pathname);
          const response = await fetch(`${root.dataset.addUrl}.js`, { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || root.dataset.errorLabel);
          added = true;
          status.textContent = root.dataset.addedLabel;
          if (result.sections && result.sections['cart-icon-bubble']) {
            const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
            const icon = document.getElementById('cart-icon-bubble');
            if (icon) icon.innerHTML = parsed.querySelector('.shopify-section').innerHTML;
          }
          const cartResponse = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!cartResponse.ok) throw new Error(root.dataset.confirmLabel);
          showCart(await cartResponse.json());
        } catch (error) {
          status.textContent = added ? root.dataset.confirmLabel : (error.message || root.dataset.errorLabel);
        } finally {
          enabledButtons.forEach((item) => { item.disabled = false; });
          button.textContent = root.dataset.addLabel;
          busy = false;
        }
      }));
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) fetch(`${root.dataset.cartUrl}.js`, { cache: 'no-store' }).then((response) => response.json()).then(showCart).catch(() => {});
      });
    };
    const initAll = () => document.querySelectorAll('[data-cookie-home]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
